import classNames from "classnames";
import { BannerItem } from "~/common/components/banner/BannerItem";
import { BannerItemAttributes } from "~/models/bannerprops";

/**
 * this front end script is responsible for controlling the card container's hide/show of the
 * content when the plus/minus button is clicked
 */
export const BannerView = ({ list }: { list: BannerItemAttributes[] }) => {
  return (
    <div
      className={classNames(
        "cn-banner-elements",
        "banner-highlights-wrapper tw:text-white",
        "tw:w-full tw:flex tw:justify-center tw:items-center tw:pt-6 lg:pt-0 tw:pb-6 lg:tw:pb-4",
      )}
    >
      <div
        className={classNames(
          "tw:w-full tw:flex tw:justify-center tw:flex-wrap tw:items-start! tw:gap-10 tw:lg:gap-20",
        )}
      >
        {list.map((item, index) => (
          <div
            key={index}
            className={classNames(
              "tw:flex tw:justify-around tw:flex-wrap tw:items-start! tw:gap-4! tw:lg:gap-8!",
              "tw:max-w-[1047px]",
            )}
          >
            <BannerItem
              key={index}
              title={item.title}
              description={item.description}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
